import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';

import {editWantedPost} from 'services/wantedPost/edit';

const useEditWantedPost = ({resetForm}: IUseEditWantedPost) => {
  const navigate = useNavigate();
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: EditwantedBody) => {
      return editWantedPost(payload);
    },
    onSuccess: (_, variables) => {
      const appType =
        variables.profile_type === 'farmer' ? 'farm' : 'wholesaler';
      navigate('/' + appType + '/my-advertisment');
      resetForm();
    },
  });
  return {isLoading, mutate};
};
export default useEditWantedPost;
